module.exports = __webpack_public_path__ + "static/img/n_2_3.ef67d4a6.png";